interface CheckboxCardProps {
  text: string;
  active: boolean;
  onClick: () => void;
}

const Checkbox = ({ text, onClick, active }: CheckboxCardProps) => {
  return (
    <button
      role="checkbox"
      aria-checked={active}
      onClick={onClick}
      className={`lc-flex lc-gap-4 lc-p-4 ${
        active ? "lc-bg-blue-primary lc-p-[18px]" : "!lc-border-solid !lc-border-2 !lc-border-cfa-blue-700"
      } lc-text-white lc-min-w-[160px] lc-text-left lc-items-center lc-leading-5 lc-min-h-[72px]`}
    >
      <span className={`lc-p-2 ${active ? "lc-bg-white" : "lc-bg-cfa-blue-700"}`}>
        <svg
          width="22"
          height="21"
          viewBox="0 0 22 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="check (9) 2">
            <path
              id="Vector"
              d="M8.21924 17.9561L1.15059 10.8874C0.983657 10.7205 0.983657 10.4498 1.15059 10.2829L3.4528 7.98067C3.61974 7.81374 3.89039 7.81374 4.05732 7.98067L8.52125 12.4446L17.9437 3.04284C18.1107 2.87622 18.3811 2.87637 18.5479 3.04317L20.8502 5.34546C21.0172 5.51249 21.0171 5.78334 20.8499 5.95023L8.82351 17.9563C8.65653 18.123 8.38608 18.1229 8.21924 17.9561Z"
              fill={active ? "#336AFF" : "#0033be"}
            />
          </g>
        </svg>
      </span>
      <span className="lc-font-azo-sans lc-text-base">{text}</span>
    </button>
  );
};

export default Checkbox;
